module.exports = __webpack_public_path__ + "img/pw-logo-color.e09cb0e1.svg";